module.exports = __webpack_public_path__ + "static/media/DSC_0186-2.db54f20d.jpg";